import { useCallback, useEffect, useState } from "react";
import { api, type Me } from "@/lib/api";

export interface UseMe {
  me: Me | null;
  loading: boolean;
  refresh: () => Promise<void>;
  setMe: (me: Me | null) => void;
}

export function useMe(): UseMe {
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const fresh = await api.me();
      setMe(fresh);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { me, loading, refresh, setMe };
}
